/**
 * Pure index math for the queue's keyboard navigation (§18 ergonomics:
 * arrows / j-k to move the highlighted row, Enter to open). DOM-free so it's
 * unit-tested in the node vitest project; the component owns the event wiring
 * and scrolling, this owns "which row is next".
 */

/**
 * Move a selection within a list of `length` rows by `delta` (+1 down, -1 up),
 * clamping at the ends (no wraparound — a packer scanning a long queue should
 * not jump from last to first). Conventions:
 *   - empty list → -1 (nothing selectable)
 *   - no current selection (current < 0): a downward move lands on the first
 *     row, an upward move on the last row.
 */
export function moveSelection(current: number, delta: number, length: number): number {
  if (length <= 0) return -1;
  if (current < 0) return delta >= 0 ? 0 : length - 1;
  const next = current + delta;
  if (next < 0) return 0;
  if (next > length - 1) return length - 1;
  return next;
}

/** Clamp an index into a valid row position, or -1 when the list is empty. */
export function clampIndex(index: number, length: number): number {
  if (length <= 0) return -1;
  if (index < 0) return 0;
  if (index > length - 1) return length - 1;
  return index;
}
